/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DashboardSalesDTO } from '../models/DashboardSalesDTO';
import type { DatePresetType } from '../models/DatePresetType';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class DashboardService {

  /**
   * @param datePreset
 *
 * 0 = Period
 *
 * 1 = Day
 *
 * 2 = Week
 *
 * 3 = Month
   * @param from 
   * @param to 
   * @param branchId 
   * @param searchEmployee 
   * @returns DashboardSalesDTO Success
   * @throws ApiError
   */
  public static getDashboardSales(
datePreset: DatePresetType,
from?: string,
to?: string,
branchId?: number,
searchEmployee?: string,
): CancelablePromise<Array<DashboardSalesDTO>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/dashboard/sales',
      query: {
        'datePreset': datePreset,
        'from': from,
        'to': to,
        'branchId': branchId,
        'searchEmployee': searchEmployee,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

}
